const defaultOptions = {
  direction: "normal",
  speed: 1
};
export { defaultOptions };
